import type { RouteRecordRaw } from 'vue-router';
import { canAccessAdminRoutes } from '@/utils/routeGuards';

const routes: RouteRecordRaw[] = [
  {
    path: '/agreements',
    name: 'Agreements',
    component: () => import('@/views/AgreementsPage.vue'),
    redirect: { name: 'AgreementsByAgreement' },
    meta: {
      layout: 'LayoutAuthenticated',
      requiresAuth: true,
      title: 'pageAgreements.metaTitle',
      layoutOptions: {
        noAppBarBorder: true,
      },
    },
    beforeEnter: [canAccessAdminRoutes],
    children: [
      {
        path: '',
        name: 'AgreementsByAgreement',
        component: () => import('@/views/AgreementsByAgreement.vue'),
      },
      {
        path: 'by-contract',
        name: 'AgreementsByContract',
        component: () => import('@/views/AgreementsByContract.vue'),
      },
    ],
  },
  {
    path: '/agreements/:agreementTwrn?',
    name: 'Agreement',
    component: () => import('@/views/AgreementPage.vue'),
    props: true,
    beforeEnter: async (to) => {
      if (!to.params.agreementTwrn) {
        return { name: 'Agreements' };
      }
      const adminCheck = await canAccessAdminRoutes();
      return adminCheck;
    },
    redirect: { name: 'AgreementOverview' },
    meta: {
      layout: 'LayoutAuthenticated',
      layoutOptions: {
        noAppBarBorder: true,
        headerHeight: 120,
      },
      requiresAuth: true,
      title: 'pageAgreementOverview.metaTitle',
    },
    children: [
      {
        path: 'overview',
        name: 'AgreementOverview',
        props: true,
        component: () => import('@/views/AgreementOverview.vue'),
      },
      {
        path: 'payment-requests',
        name: 'AgreementPaymentRequests',
        component: () => import('@/views/AgreementPaymentRequests.vue'),
        props: true,
      },
      {
        path: 'athletes',
        name: 'AgreementAthletes',
        props: true,
        component: () => import('@/views/AgreementAthletes.vue'),
      },
    ],
  },
  {
    path: '/agreements/create/:agreementTwrn?',
    name: 'CreateAgreement',
    component: () => import('@/views/CreateAgreement.vue'),
    props: true,
    meta: {
      layout: 'LayoutAuthenticated',
      requiresAuth: true,
      title: 'pageCreateAgreement.metaTitle',
      layoutOptions: {
        hideAppBar: true,
      },
    },
    beforeEnter: [canAccessAdminRoutes],
  },
];

export default routes;
